export function parseIceServerUrl(url: string): RTCIceServer | null {
  const standardTurnRegex = /^turns?:\/\/?([^@]+)@([^:]+):(\d+)$/i;
  const matchStandard = url.match(standardTurnRegex);

  if (matchStandard) {
    const [, credentials, host, port] = matchStandard;
    const [username, password] = credentials.split(':');
    if (!username || !password) {
      console.warn("TURN URL has invalid credentials format — skipping:", url);
      return null;
    }
    return {
      urls: [`turn:${host}:${port}`],
      username,
      credential: password,
    };
  }


  const customTurnRegex = /^turns?:([^@]+)@([^:]+):([^:]+):(\d+)$/i;
  const matchCustom = url.match(customTurnRegex);

  if (matchCustom) {
    const [, username, password, host, port] = matchCustom;
    return {
      urls: [`turn:${host}:${port}`],
      username,
      credential: password,
    };
  }

  // Support bare format without prefix: username@password:host:port
  const bareTurnRegex = /^([^@]+)@([^:]+):([^:]+):(\d+)$/i;
  const matchBare = url.match(bareTurnRegex);

  if (matchBare) {
    const [, username, password, host, port] = matchBare;
    return {
      urls: [`turn:${host}:${port}`],
      username,
      credential: password,
    };
  }

  if (url.startsWith("turn:") || url.startsWith("turns:")) {
    console.warn("TURN server URL provided without username and credential — skipping:", url);
    return null;
  }

  return { urls: [url] };
}

export function parseIceServers(input: any): RTCIceServer[] {
  if (!Array.isArray(input)) {
    console.warn("ICE servers input is not an array:", input);
    return [];
  }

  return input.flatMap((server: any) => {
    if (typeof server === 'string') {
      try {
        const parsed = parseIceServerUrl(server);
        return parsed ? [parsed] : [];
      } catch (error) {
        console.warn("Skipping invalid ICE server string:", server, error);
        return [];
      }
    } else if (typeof server === 'object' && server.urls) {
      // If username/credential are provided at the server level, keep as-is
      if (server.username && server.credential) {
        return [server as RTCIceServer];
      }

      const urls = Array.isArray(server.urls) ? server.urls : [server.urls];
      return urls
        .map((url: string | RTCIceServer) => {
          if (typeof url === 'string') {
            try {
              return parseIceServerUrl(url);
            } catch (error) {
              console.warn("Skipping invalid ICE server URL:", url, error);
              return null;
            }
          }

          if (
            typeof url === 'object' &&
            url.urls &&
            Array.isArray(url.urls) &&
            url.urls.some((u: string) => u.startsWith("turn:") || u.startsWith("turns:")) &&
            (!url.username || !url.credential)
          ) {
            console.warn("TURN server missing username or credential — skipping:", url);
            return null;
          }

          return url as RTCIceServer;
        })
        .filter((item: RTCIceServer | null): item is RTCIceServer => item !== null);
    } else {
      console.warn("Unknown ICE server format:", server);
      return [server];
    }
  });
}
